var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-back-black",
    clipPath: "url(#clip0_118_27624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 10.9997H7.82998L12.71 6.11973C13.1 5.72973 13.1 5.08973 12.71 4.69973C12.32 4.30973 11.69 4.30973 11.3 4.69973L4.70998 11.2897C4.31998 11.6797 4.31998 12.3097 4.70998 12.6997L11.3 19.2897C11.69 19.6797 12.32 19.6797 12.71 19.2897C13.1 18.8997 13.1 18.2697 12.71 17.8797L7.82998 12.9997H19C19.55 12.9997 20 12.5497 20 11.9997C20 11.4497 19.55 10.9997 19 10.9997Z",
    fill: "#6A696E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_27624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackBlack);
export default __webpack_public_path__ + "static/media/arrow-back-black.410794d76bec88f8654cb98e20f070a3.svg";
export { ForwardRef as ReactComponent };